export default "__VITE_ASSET__ff47ba2f__"